import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { obterMotivoNaoConseguiu, enviarMotivoNaoConseguiu, MOTIVOS_NAO_CONSEGUIU } from "../services/api";

/**
 * "Por que você não conseguiu se candidatar?" — página do link do e-mail, SEM login.
 *
 * Segundo checkpoint do "não consegui" (pedido do Nelson, 11/09/2026). É informação NOSSA, não relato: não vai
 * para a empresa e não entra na reputação — a página diz isso logo no topo, porque quem acha que está
 * "denunciando" escreve outra coisa (ou não escreve nada).
 *
 * Cabeçalho enxuto, sem "Entrar": ver FeedbackCandidaturaPage — um botão de login no topo já fez gente
 * concluir que precisava de conta para responder três perguntas.
 */
const Tela = ({ children }) => (
  <div className="min-h-screen bg-background">
    <header className="border-b border-gray-200 bg-white">
      <div className="max-w-2xl mx-auto px-4 md:px-6 py-4">
        <a href="/" className="text-lg font-extrabold text-primary">eaiRH</a>
      </div>
    </header>
    <main className="max-w-2xl mx-auto px-4 md:px-6 py-10">{children}</main>
  </div>
);

export default function MotivoPage() {
  const { token } = useParams();
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState("");
  const [motivo, setMotivo] = useState(null);
  const [texto, setTexto] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [pronto, setPronto] = useState(false);

  useEffect(() => {
    obterMotivoNaoConseguiu(token)
      .then((d) => { setDados(d); if (d?.jaRespondeu) setPronto(true); })
      .catch(() => setErro("Não encontramos este link. Ele pode ter sido digitado incompleto."));
  }, [token]);

  async function enviar() {
    if (!motivo) return;
    setEnviando(true); setErro("");
    try {
      await enviarMotivoNaoConseguiu(token, { motivo, texto: texto.trim() || null });
      setPronto(true);
    } catch (e) {
      setErro(e.message || "Não conseguimos registrar agora. Tente de novo em instantes.");
    } finally { setEnviando(false); }
  }

  if (erro && !dados) return <Tela><p className="text-gray-700">{erro}</p></Tela>;
  if (!dados) return <Tela><p className="text-gray-400">Carregando...</p></Tela>;

  if (pronto) {
    return (
      <Tela>
        <h1 className="text-2xl font-bold text-gray-900">Obrigado por contar</h1>
        <p className="mt-3 text-gray-700">
          Isso ajuda a gente a melhorar o caminho até a vaga, para você e para quem vem depois.
        </p>
        {motivo === "curriculo_arquivo" && (
          <div className="mt-5 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
            <b>Dica:</b> o eaiRH gera o seu currículo em PDF a partir do que você preencher no site. Depois é só
            anexar no formulário da empresa.
            <a href="/curriculo" className="block mt-2 font-semibold text-orange-700 underline">Montar e baixar meu currículo em PDF</a>
          </div>
        )}
        <a href="/vagas" className="inline-block mt-6 rounded-xl bg-primary text-white font-semibold px-5 py-2.5">
          Ver outras vagas abertas
        </a>
      </Tela>
    );
  }

  return (
    <Tela>
      <h1 className="text-2xl font-bold text-gray-900">O que aconteceu?</h1>
      <p className="mt-2 text-gray-700">
        Você não conseguiu se candidatar à vaga <b>{dados.vaga}</b>{dados.empresa ? <>, na <b>{dados.empresa}</b></> : null}.
      </p>
      <p className="mt-2 text-sm text-gray-600 rounded-xl border border-blue-200 bg-blue-50 px-3 py-2">
        Isto <b>não é um relato público</b> e não vai para a empresa. É só para nós entendermos onde o caminho trava.
      </p>

      <div className="mt-6 flex flex-col gap-2">
        {MOTIVOS_NAO_CONSEGUIU.map((m) => (
          <button key={m.v} type="button" onClick={() => setMotivo(m.v)}
            className={`max-w-full whitespace-normal text-left rounded-xl border px-4 py-2.5 text-sm font-semibold ${motivo === m.v
              ? "border-primary bg-primary text-white" : "border-gray-300 bg-white text-gray-700 hover:bg-gray-50"}`}>
            {m.t}
          </button>
        ))}
      </div>

      <label className="block mt-5">
        <span className="text-sm font-semibold text-gray-700">Quer contar com as suas palavras? (opcional)</span>
        <textarea value={texto} onChange={(e) => setTexto(e.target.value)} rows={4} maxLength={1000}
          placeholder="Ex.: pediu o currículo em PDF e eu só tinha no papel"
          className="mt-1.5 w-full rounded-xl border border-gray-300 px-3 py-2.5 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30" />
      </label>

      {erro && <p className="mt-3 text-sm font-semibold text-red-600">{erro}</p>}
      <button type="button" onClick={enviar} disabled={!motivo || enviando}
        className="mt-5 w-full rounded-xl bg-orange-600 hover:bg-orange-700 text-white font-bold px-6 py-3 disabled:opacity-50">
        {enviando ? "Enviando..." : "Enviar"}
      </button>
    </Tela>
  );
}
